export const menus = [
  { url: "/", label: "Home" },
  { url: "/issue", label: "Issue" },
  { url: "/activities", label: "Activities" },
  { url: "/about", label: "About" },
]
